import { Injectable } from '@angular/core';
import { DomainConfig } from '../../config/domain.config';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApiVersionInterceptor implements HttpInterceptor {

  constructor() {}

  
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    
    let updatedUrl = req.url;
    
    // 🟦 2. If corporate → convert apiV2 → apiCorporateV2
    if (DomainConfig.isCorporate) {
      updatedUrl = updatedUrl.replace('apiV2', 'apiCorporateV2');
    }

    const clonedReq = req.clone({ url: updatedUrl });
    return next.handle(clonedReq);
  }
}
